import React, { Component } from "react";
import { Formik } from "formik";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography
} from "@material-ui/core";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { withAlert } from "react-alert";
import styled from "styled-components";
import Dialog from "../../../waybee-ui/Dialog";
import ClassPlanService from "../../../services/ClassPlanService";

const validationSchema = Yup.object().shape({
  content: Yup.string().required(),
  observation: Yup.string()
});

const SubmitButton = styled(Button)`
  margin-top: 30px;
`;

class ClassPlanDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      classPlan: props.selectedPlan,
      loading: false
    };
  }

  createEffectiveContent = async values => {
    const { alert, selectedPlan } = this.props;
    const classPlan = {
      IDTURMADISC: selectedPlan.IDTURMADISC,
      IDPLANOAULA: selectedPlan.IDPLANOAULA,
      CONTEUDO: selectedPlan.CONTEUDO,
      CONTEUDOEFETIVO: values.content,
      CONFIRMADO: selectedPlan.CONFIRMADO,
      OBSERVACAO: values.observation
    };

    this.setState({ loading: true });

    return ClassPlanService.sendClassPlanContent(classPlan).then(() => {
      this.setState({ loading: false });
      alert.show("Conteúdo efetivado com sucesso", {
        title: "Conteúdo efetivado"
      });
    });
  };

  render() {
    const { open, onClose, alert } = this.props;
    const { classPlan, loading } = this.state;

    return (
      <Dialog
        scroll="body"
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        closeButton
      >
        {loading ? (
          <Box p={6} textAlign="center">
            <CircularProgress />
          </Box>
        ) : (
          <Box p={3}>
            <Typography variant="h2">
              {classPlan.CONTEUDOEFETIVO !== ""
                ? "Detalhes"
                : "Efetivar conteúdo"}
            </Typography>
            <Grid container>
              <Formik
                validateOnBlur
                validateOnChange={false}
                initialValues={{
                  previewContent: classPlan.CONTEUDO,
                  content: classPlan.CONTEUDOEFETIVO
                    ? classPlan.CONTEUDOEFETIVO
                    : classPlan.CONTEUDO,
                  observation: classPlan.OBSERVACAO
                }}
                validationSchema={validationSchema}
                onSubmit={values => {
                  this.createEffectiveContent(values)
                    .then(onClose)
                    .catch(e => {
                      alert.show(e.message, {
                        title: "Erro ao Efetivar Conteúdo"
                      });
                      return e;
                    });
                }}
              >
                {({ values, errors, handleChange, handleSubmit }) => (
                  <Box pt={2} width="100%">
                    {classPlan.CONTEUDO && (
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            name="previewContent"
                            fullWidth
                            multiline
                            disabled
                            rows="8"
                            variant="outlined"
                            label="Planejamento do conteúdo"
                            value={values.previewContent}
                            error={errors.previewContent}
                            onChange={handleChange}
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          name="content"
                          fullWidth
                          multiline
                          rows="8"
                          variant="outlined"
                          label="Conteúdo"
                          value={values.content}
                          error={errors.content}
                          onChange={handleChange}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          name="observation"
                          fullWidth
                          multiline
                          rows="6"
                          variant="outlined"
                          label="Observação"
                          value={values.observation || ""}
                          error={errors.observation}
                          onChange={handleChange}
                        />
                      </Grid>
                    </Grid>
                    <Grid container justify="center" rowSpacing={6}>
                      <SubmitButton
                        onClick={handleSubmit}
                        variant="contained"
                        color="primary"
                        mt={4}
                      >
                        {classPlan.CONTEUDOEFETIVO !== ""
                          ? "Salvar alterações"
                          : "Salvar"}
                      </SubmitButton>
                    </Grid>
                  </Box>
                )}
              </Formik>
            </Grid>
          </Box>
        )}
      </Dialog>
    );
  }
}

ClassPlanDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  selectedPlan: PropTypes.objectOf().isRequired,
  alert: PropTypes.shape({
    show: PropTypes.func
  }).isRequired
};

ClassPlanDialog.defaultProps = {
  open: false,
  onClose: () => {}
};

export default withAlert()(ClassPlanDialog);
